import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class BackButtonService {
  private backFunction!: () => void;

  constructor(private location: Location, private router: Router) {
    this.resetBackFunction();
  }

  setCustomBackFunction(customFunction: () => void) {
    this.backFunction = customFunction;
  }

  goBack() {
    if (this.backFunction) {
      this.backFunction();
    }
  }

  resetBackFunction() {
    this.backFunction = () => this.location.back();
  }
}
